module.exports = __webpack_public_path__ + "img/Case_3.193d7938.jpg";